var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toMoney, toDateTime, toPorciento } from 'helpers/Format';
import TicketsReport from '../components/TicketsReport';
import history from 'helpers/History';
let TicketCanceled = class TicketCanceled extends Component {
    constructor() {
        super(...arguments);
        this.findUser = (lista, id) => {
            const result = lista.find(value => value.id === id);
            return result ? result.name : '';
        };
        this.handleOnSelectItem = (item) => {
            console.error(item.id);
            history.push(`/tickets/${item.id}`, item);
        };
    }
    componentDidMount() {
        console.log('TicketGratis - componentDidMount');
        this.props.store.reports.readTicketCanceled();
    }
    render() {
        const { reports } = this.props.store;
        const headers = ['businessUnit', 'operationLine', 'stretch', 'numero', 'user', 'datecheck', 'datevalited', 'daterefund', 'discount', 'codeDiscount', 'terminal', 'netAmount', 'taxAmount', 'total'];
        const items = reports.ticketGratis;
        return (React.createElement(TicketsReport, { onSelectItem: this.handleOnSelectItem, search: true, header: headers, items: items, total: (tickets) => tickets.reduce((sum, item) => item.total + sum, 0), loading: !reports.ticketGratisLoaded, keyExtractor: (ticket) => String(ticket.id), format: (tickets) => tickets.map(ticket => (Object.assign(Object.assign({}, ticket), { businessUnit: ticket.businessUnit, operationLine: ticket.operationLine, stretch: ticket.stretch, datecheck: toDateTime(ticket.datecheck), datevalited: toDateTime(ticket.datevalited), daterefund: ticket.daterefund !== null ? toDateTime(ticket.daterefund) : '', discount: toPorciento(ticket.discount), codeDiscount: ticket.codeDiscount, netAmount: toMoney(ticket.netAmount), taxAmount: toMoney(ticket.taxAmount), 
                /*taxBase: toMoney(ticket.taxBase),*/
                total: toMoney(ticket.total), 
                // user: ticket.user// this.findUser(this.props.store.users.users, ticket.user_id)
                user: ticket.username }))) }));
    }
};
TicketCanceled = __decorate([
    inject('store'),
    observer
], TicketCanceled);
export default TicketCanceled;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketCanceled.tsx
// module id = 532
// module chunks = 0